/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React from "react";
import { BagDetailsUI } from "@innofulfill/hubops-shipment-tracking";
import { useLocation } from "react-router-dom";
import urls from "../api/urls";

function BagDetails(props) {
  const { awbNumber: propAwbNumber } = props || {};
  const location = useLocation();

  // URL params se awbNumber nikalna
  const params = new URLSearchParams(location.search);
  const awbNumber = propAwbNumber || params.get("awb") || params.get("awbNumber") || "";

  // Fixed endpoint
  const endpoint = urls.SHIPMENT_TRACKING_ENDPOINT;

  return (
    <BagDetailsUI
      endpoint={endpoint}
      awbNumber={awbNumber}
      showBackArrow={true}
    />
  );
}

export default BagDetails;
